export default {
  set: 'USER_MUTATIONS_SETUSER',
  setToken: 'USER_MUTATIONS_SETTOKEN',
  setLocale: 'USER_MUTATIONS_SET_LOCALE'
}
